import { Navigate, useSearchParams } from "react-router-dom";

import WhatsAppTemplatesManager from "../components/whatsapp/WhatsAppTemplatesManager";
import useWhatsAppEnabled from "../hooks/useWhatsAppEnabled";
import { whatsappTemplatesPath } from "../utils/whatsappRoutes";
import TemplatesPage from "./TemplatesPage";

export function WhatsAppTemplatesRedirect() {
  const [searchParams] = useSearchParams();
  const whatsappEnabled = useWhatsAppEnabled();
  if (!whatsappEnabled) {
    return <Navigate to="/templates" replace />;
  }
  return <Navigate to={whatsappTemplatesPath(searchParams.get("numero"))} replace />;
}

export default function TemplatesHubPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const whatsappEnabled = useWhatsAppEnabled();
  const whatsappRequested = searchParams.get("canal") === "whatsapp";

  if (whatsappRequested && !whatsappEnabled) {
    return <Navigate to="/templates" replace />;
  }

  if (whatsappRequested) {
    return <WhatsAppTemplatesManager />;
  }

  return <TemplatesPage onOpenWhatsApp={() => setSearchParams({ canal: "whatsapp" })} />;
}
